// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"f48996d2","413":"aed3d668","623":"9d3c02b2"}[chunkId] + ".chunk.css";
};